import { combineEpics, ofType } from 'redux-observable';
import { map, catchError, switchMap, debounceTime } from 'rxjs/operators';
import { createErrorStream } from 'common/store/error/index';

import {
  LOAD, load, loadSuccess, loadError,
  TOGGLE_SORT, SEARCH, PAGINATION_CHANGE,
} from './actions';

import {
  getStoreParams,
} from './selectors';

const loadEpic = (action, state, { deviceService }) => action.pipe(
  ofType(LOAD),
  switchMap(action$ => deviceService
    .getAlarms(getStoreParams(state.value))
    .pipe(
      map(loadSuccess),
      catchError(createErrorStream(action$, loadError)),
    )),
);

const updateEpic = action => action.pipe(
  ofType(TOGGLE_SORT, PAGINATION_CHANGE),
  map(load),
);

const searchEpic = action => action.pipe(
  ofType(SEARCH),
  debounceTime(150),
  map(load),
);

export default combineEpics(
  loadEpic,
  updateEpic,
  searchEpic,
);
